<template>
  <Modal v-model="setPrintBarcodeModal" class-name="setPrintBarcodeStyle" :title="printBarcodeTitle" width="900"
    :transfer="false" :mask-closable="false" @on-visible-change="setPrintBarcodeModalChange">
    <Card dis-hover>
      <Form ref="setPrintBarcodeForm" :model="setPrintBarcodeForm" :label-width="110" @submit.native.prevent>
        <Row type="flex">
          <!--介质材料-->
          <Col span="24">
            <Form-item :label="$t('key1002242')">
              <span class="font-size-12">{{ $t('key1000851') }}</span>
              <InputNumber
                v-model.trim="setPrintBarcodeForm.width"
                :max="100"
                :min="0"
                @on-change="(val) =>changeSize(val, 'width')"
                class="ml10 mr10 width_70">
              </InputNumber>
              <span class="mr30">mm</span>
              <span class="font-size-12">{{ $t('key1000852') }}</span>
              <InputNumber
                v-model.trim="setPrintBarcodeForm.height"
                :max="100"
                :min="0"
                @on-change="(val) =>changeSize(val, 'height')"
                class="ml10 mr10 width_70">
              </InputNumber>
              <span>mm</span>
              <span style="color:red;" class="font-size-12 ml30">{{ $t('key1001147') }} X 100mm</span>
            </Form-item>
          </Col>
          <!--标签大小-->
          <Col span="24">
            <Form-item :label="$t('key1002243')">
              <div class="flex align-items-center">
                <span class="font-size-12">{{ $t('key1002246') }}</span>
                <InputNumber
                  :max="100"
                  v-model.trim="setPrintBarcodeForm.barcodeSize"
                  class="ml10 mr10 width_70"
                  @on-change="(val)=> changeBarSize(val, 'barcodeSize')">
                </InputNumber>
                <span class="mr30">pt</span>
                <span style="color:red;" class="font-size-12">{{ $t('key1002247') }}</span>
              </div>
            </Form-item>
          </Col>
          <!--打印库区、库位设置-->
          <Col span="24">
            <Form-item :label="labelTitle +'：'">
              <div class="flex align-items-center">
                <Select style="width:150px;" v-model="setPrintBarcodeForm.code" @on-change="changeProNo">
                  <Option :value="0">{{ $t('key1001135') + labelTitle }}</Option>
                  <Option :value="1">{{ $t('key1000320') + labelTitle }}</Option>
                </Select>
                <!--库区、库位代码字体大小设置-->
                <div v-if="setPrintBarcodeForm.code === 1">
                  <span class="font-size-12 ml20">{{ labelTitle + $t('key1001148') }}</span>
                  <InputNumber
                    :max="100"
                    v-model.trim="setPrintBarcodeForm.codeSize"
                    style="width:70px;"
                    class="ml10 mr10"
                    @on-change="(val) => changeBarSize(val, 'codeSize')">
                  </InputNumber>
                  <span>pt</span>
                </div>
              </div>
            </Form-item>
          </Col>
          <!--自定义内容-->
          <Col span="24">
            <Form-item :label="$t('key1002244')">
              <div class="flex align-items-center">
                <Select style="width:150px" v-model="setPrintBarcodeForm.custom" @on-change="changeCustom">
                  <Option :value="0">{{ $t('key1002248') }}</Option>
                  <Option :value="1">{{ $t('key1002249') }}</Option>
                </Select>
                <template v-if="setPrintBarcodeForm.custom">
                  <span class="font-size-12 ml20">{{ $t('key1002245') }}</span>
                  <InputNumber
                    :max="100"
                    v-model.trim="setPrintBarcodeForm.customSize"
                    style="width:70px;"
                    class="ml10 mr10"
                    @on-change="(val) => changeBarSize(val, 'customSize')">
                  </InputNumber>
                  <span>pt</span>
                  <Input v-model.trim="tagContent" class="width_150 ml20" @on-enter="addTag"></Input>
                  <Button class="ml10" type="primary" size="small" @click="addTag">{{ $t('key1002250') }}</Button>
                </template>
              </div>
              <Col span="24" class="mt10">
                <Tag
                  v-if="setPrintBarcodeForm.custom"
                  v-for="(item, index) in tagList"
                  :key="index"
                  closable
                  @on-close="delConfirm(index)"
                  style="margin:5px;">
                  {{ item }}
                </Tag>
              </Col>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </Card>
    <Row type="flex" class="mt10" :gutter="10">
      <Col span="12">
        <div class="flex justify-content-between align-items-center mb10">
          <h3>{{ tableTitle }}</h3>
          <div class="flex align-items-center">
            <span class="mr10">{{ $t('key1002251') }}</span>
            <InputNumber v-model.trim="printNum" style="width:60px" :min="1" :max="999999" @on-change="changePrintNum"></InputNumber>
          </div>
        </div>
        <Table border :columns="printColumns" max-height="350" :data="printData"></Table>
      </Col>
      <Col span="12">
        <div class="mt10 mb10" style="color:green; width: 100%; text-align: right;">{{ $t('key1002252') }}</div>
        <Card dis-hover class="print_display_style">
          <div :style="pageClass" ref="container" class="container" v-if="printData.length > 0">
            <div
              ref="draggable1"
              class="draggable draggable_box"
              data-name="codeBarcode"
              :style="barCodeClass"
              v-show="printData.length"
              v-html="entityToString(printData[0][printViewParams[0]])">
            </div>
            <div
              ref="draggable2"
              class="draggable draggable_box"
              :style="codeClass"
              data-name="code"
              v-show="printData.length && setPrintBarcodeForm.code">{{ printData[0][printViewParams[1]] }}
            </div>
            <template v-if="tagList.length" v-for="(item, index) in tagList">
              <div
                :style="customClass"
                style="position: absolute !important;"
                :ref="'draggable' + (index + 4)"
                class="draggable draggable_box" :key="index">
                {{ item }}
              </div>
            </template>
          </div>
        </Card>
      </Col>
    </Row>
    <template #footer>
      <Button @click="setPrintBarcodeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="setPrintBarcodeBtn">{{ $t('key1000320') }}</Button>
    </template>

    <div ref="tagTemp" style="display: none;"></div>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import Draggabilly from 'draggabilly';

export default {
  name: "setPrintBarcodeModal",
  mixins: [Mixin],
  props: {
    // 打印条码的标题
    printBarcodeTitle: {
      type: String,
      default: ''
    },
    // 标签名称
    labelTitle: {
      type: String,
      default: ''
    },
    // 列表的标题
    tableTitle: {
      type: String,
      default: ''
    },
    // 表格参数
    printColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 表格数据
    printData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 参数
    printViewParams: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      setPrintBarcodeModal: false,
      setPrintBarcodeForm: {
        width: 60,
        height: 40,
        barcodeSize: 12,
        code: 1,
        codeSize: 12,
        custom: 0,
        customSize: 12
      },
      tagContent: null,
      tagList: [],
      printNum: 1,
      pageClass: {
        width: '169.8pt',
        height: '113.2pt',
        background: '#fff',
        textAlign: 'center',
        position: 'relative'
      },
      barCodeClass: {
        fontFamily: 'IDAutomationC128S',
        lineHeight: '22pt',
        fontSize: '12pt'
      },
      codeClass: {
        fontSize: '12pt'
      },
      customClass: {
        fontSize: '12pt'
      },
      FixedValue: 2.83,
    };
  },
  methods: {
    // 打印按钮
    setPrintBarcodeBtn() {
      let v = this;
      v.publicPrintBtn('yms-core-service', v.htmlText()).then(() => {
        v.setPrintBarcodeModal = false;
      });
    },
    htmlText(callback) {
      let v = this;
      let str = '';
      let dom = v.deepCopy(v.$refs.container);
      let tagTemp = v.$refs.tagTemp;
      tagTemp.innerHTML = dom.parentNode.innerHTML;
      let container = tagTemp.childNodes[0];
      if (v.printData.length > 0) {
        v.printData.forEach((n) => {
          for (let i = 0; i < n.printQuantity; i++) {
            container.childNodes[0].innerText = v.entityToString(n[v.printViewParams[0]]);
            if (v.setPrintBarcodeForm.code) {
              container.childNodes[1].innerHTML = n[v.printViewParams[1]];
            }
            callback && callback();
            str += tagTemp.innerHTML;
          }
        });
        return str;
      }
    },
    // 监听弹窗
    setPrintBarcodeModalChange(value) {
      let v = this;
      if (value) {
        v.$nextTick(() => {
          v.showPrint();
          v.getLocal();
        });
      } else {
        v.tagList = [];
        v.printNum = 1;
        v.$emit("printBarcodeModalChange");
      }
    },
    // 获取默认的设置参数
    getLocal() {
      let data = localStorage.getItem('printSetting');
      if (data) {
        let localDate = JSON.parse(data);
        this.pageClass.width = (localDate.width * this.FixedValue) + 'pt';
        this.pageClass.height = (localDate.height * this.FixedValue) + 'pt';
        let printBarcodeFormKeyList = ['width', 'height', 'barcodeSize', 'code', 'codeSize', 'custom', 'customSize'];
        this.barCodeClass.fontSize = localDate['barcodeSize'] + 'pt';
        this.codeClass.fontSize = localDate['codeSize'] + 'pt';
        this.customClass.fontSize = localDate['customSize'] + 'pt';
        printBarcodeFormKeyList.map((key) => {
          if (localDate[key]) {
            this.setPrintBarcodeForm[key] = localDate[key];
          }
        });
        this.$forceUpdate();
      } else {
        localStorage.setItem('printSetting', JSON.stringify(this.setPrintBarcodeForm));
      }
      this.getPosition();
    },
    // 获取本地位置
    getPosition() {
      let data = localStorage.getItem('positionPrint');
      if (data) {
        let localDate = JSON.parse(data);
        localDate.forEach((i) => {
          if (i.key === 'codeBarcode') {
            // 条形码
            this.$refs.draggable1.style.top = i.top;
          } else if (i.key === 'code') {
            this.$refs.draggable2.style.top = i.top;
          }
        });
      }
    },
    // 缓存设置参数
    setLocal(key, value) {
      let data = localStorage.getItem('printSetting') ? JSON.parse(localStorage.getItem('printSetting')) : {};
      data[key] = value;
      localStorage.setItem('printSetting', JSON.stringify(data));
    },
    // 介质材料的宽高设置
    changeSize(val, type) {
      let v = this;
      v.pageClass[type] = (val * v.FixedValue) + 'pt';
      v.setLocal(type, val);
    },
    // 设置字体大小
    changeBarSize(val, type) {
      let v = this;
      switch (type) {
        // 条码字体
        case 'barcodeSize':
          v.barCodeClass.fontSize = val + 'pt';
          break;
        // 库区、库位字体
        case 'codeSize':
          v.codeClass.fontSize = val + 'pt';
          break;
        // 自定义内容字体
        case 'customSize':
          v.customClass.fontSize = val + 'pt';
          break;
      }
      v.setLocal(type, val);
    },
    // 选择代码
    changeProNo(val) {
      if (val) {
        this.showPrint();
      }
      this.setLocal('code', val);
    },
    // 设置打印展示模块
    showPrint() {
      let el = [];
      el.push(this.$refs.draggable1);
      el.push(this.$refs.draggable2);
      let arr = [];
      el.forEach((n) => {
        let drag;
        drag = new Draggabilly(n, {
          // 选项...
          containment: true,
          axis: 'xy'
        });
        arr.push(drag);
      });
      arr.forEach((i, index) => {
        i.on('dragEnd', (e) => {
          // 设置位置
          let data = localStorage.getItem('positionPrint') ? JSON.parse(localStorage.getItem('positionPrint')) : [];
          data[index] = {
            left: e.target.style.left,
            top: e.target.style.top,
            key: el[index].getAttribute('data-name')
          };
          localStorage.setItem('positionPrint', JSON.stringify(data));
        });
      });
    },
    // 自定义内容
    changeCustom(val) {
      this.setLocal('custom', val);
    },
    // 添加自定义内容标签
    addTag() {
      let v = this;
      if (v.tagContent) {
        v.tagList.push(v.tagContent);
        v.tagContent = null;
        v.$nextTick(() => {
          new Draggabilly(this.$refs['draggable' + (v.tagList.length + 3)][0], {
            containment: true,
            axis: 'xy'
          });
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002241'));
        return false;
      }
    },
    // 移除自定义内容标签
    delConfirm(idnex) {
      let v = this;
      v.tagList.splice(idnex, 1);
    },
    // 统一设置打印数量
    changePrintNum(value) {
      let v = this;
      v.$emit('changePrintNum', value);
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .setPrintBarcodeStyle {
  .ivu-modal-body {
    max-height: 700px;
    overflow-y: auto;
  }

  .print_display_style {
    width: 100%;
    height: 350px;
    background: #e8e8e8;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .draggable_box {
    cursor: move;
    display: inline-block;
  }
}

</style>
